export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--circle-arrow.36800c71.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};